(function(){
  if (customElements.get('gd-buy-box')) return;

  class GDBuyBox extends HTMLElement {
    constructor(){
      super();
      this.mode = 'once';
      this.state = {
        once:   { size:null, blend:null, grind:null, qty:1 },
        sub:    { size:null, blend:null, grind:null, qty:1, freq:null },
        bundle: { count:3, size:null, grind:null, blends:[null,null,null], qty:1 }
      };
    }

    connectedCallback(){
      try { this.variants = JSON.parse(this.dataset.variants); } catch(e){ this.variants = []; }
      try { this.plans    = JSON.parse(this.dataset.plans);    } catch(e){ this.plans = []; }
      this.plans = this.normalizePlans(this.plans);
      this.hasGrind  = this.dataset.hasGrind === 'true';
      this.disc2     = parseFloat(this.dataset.disc2) || 0;
      this.disc3     = parseFloat(this.dataset.disc3) || 0;
      this.subDisc   = parseFloat(this.dataset.subDisc) || 0;
      this.subMode   = this.dataset.subMode || 'mock';
      this.subLink   = this.dataset.subLink || '';
      this.redirect  = this.dataset.redirect || 'drawer';
      this.subExclude = (this.dataset.subExclude || '').split(',').map(s=>s.trim()).filter(Boolean);
      this.manageLink  = this.dataset.manageLink || '';
      this.assureText  = this.dataset.assure || '';
      this.assureLabel = this.dataset.assureLabel || '';
      this.defaultMode = this.dataset.defaultMode || 'once';
      this.showSub = this.dataset.showSub !== 'false';
      this.productImage = this.dataset.productImage || '';
      this.productTitle = this.dataset.productTitle || '';
      // Pantry blend cue (change c, 09 Oct 2026): gate on the product handle,
      // derived from data-product-url (the section emits product.url). Keeps the
      // "Milk or black?" helper on the Pantry Bags product only.
      this.productUrl = this.dataset.productUrl || '';
      this.productHandle = (this.productUrl.match(/\/products\/([^/?#]+)/) || [])[1] || '';

      // Derive the distinct option values from the variant map
      this.sizes  = this.sortSizes(this.distinct('size'));
      this.grinds = this.hasGrind ? this.distinct('grind') : [];
      this.blends = this.readBlends();
      this.hasBlend = this.blends.length > 0;
      // Sold-out awareness: data-variants carries Liquid's variant.available for
      // every variant. allSoldOut drives the on-load "Sold out" notice.
      this.allSoldOut = this.variants.length > 0 && !this.variants.some(v=> this.isAvail(v));

      // sensible defaults: middle-ish size, first blend, whole-bean grind if present
      const defaultSize = this.sizes[Math.min(1, this.sizes.length-1)] || this.sizes[0] || null;
      const defaultGrind = this.grinds.find(g=>/whole/i.test(g)) || this.grinds[0] || null;
      this.state.once.size = defaultSize;
      this.state.once.blend = this.blends[0] ? this.blends[0].value : null;
      this.state.once.grind = defaultGrind;
      this.state.sub.size = this.subSizes()[0] || defaultSize;
      this.state.sub.blend = this.state.once.blend;
      this.state.sub.grind = defaultGrind;
      this.state.bundle.size = defaultSize;
      this.state.bundle.grind = defaultGrind;
      this.state.bundle.blends = [this.state.once.blend, this.blends[1]?this.blends[1].value:this.state.once.blend, null];

      this.panel = this.querySelector('[data-panel]');
      this.errorEl = this.querySelector('[data-error]');
      this.giftTpl = this.querySelector('[data-gift-template]');

      // Single-origin products have no blend option: hide the Bundle toggle
      // (you can't "mix" a single origin). Blend picker is skipped in blendRadios.
      if (!this.hasBlend){
        const _bt = this.querySelector('.gd-buybox__bundle-toggle');
        if (_bt) _bt.style.display = 'none';
      }

      // Single-purchase products (e.g. Sample Box): hide Subscribe entirely.
      // With no Subscribe and no Bundle there's only one mode, so drop the tablist.
      if (!this.showSub){
        const _sub = this.querySelector('.gd-buybox__mode--sub');
        if (_sub) _sub.style.display = 'none';
        if (!this.hasBlend){
          const _modes = this.querySelector('.gd-buybox__modes');
          if (_modes) _modes.style.display = 'none';
        }
      }

      this.querySelectorAll('[data-mode]').forEach(btn=>{
        btn.addEventListener('click', ()=> this.switchMode(btn.dataset.mode, btn));
      });

      // Entry-point URL params: ?gd_size=N pre-selects a pack size (e.g. the
      // 12-pack Entry Pack); ?gd_entry=1 flags the Entry Pack landing (badge).
      let _ep = null;
      try { _ep = new URLSearchParams(window.location.search); } catch(e){ _ep = null; }
      if (_ep){
        const wantSize = _ep.get('gd_size');
        if (wantSize){
          const target = parseFloat(wantSize) || 0;
          const match = this.sizes.find(s => this.sizeWeight(s) === target);
          if (match){
            this.state.once.size = match;
            this.state.bundle.size = match;
            if (this.subSizes().indexOf(match) > -1) this.state.sub.size = match;
          }
        }
        // ?blend=gadabout (etc.) — the Decaf collection deep-links here so the
        // picker opens straight on the decaf / Gadabout blend.
        const wantBlend = _ep.get('blend');
        if (wantBlend && this.blends.length){
          const _norm = function(s){ return String(s).toLowerCase().replace(/[^a-z0-9]/g,''); };
          const _tok = _norm(wantBlend);
          if (_tok){
            const _bm = this.blends.find(function(b){ return _norm(b.value).indexOf(_tok) === 0; })
                     || this.blends.find(function(b){ return _norm(b.value).indexOf(_tok) > -1; });
            if (_bm){
              this.state.once.blend = _bm.value;
              this.state.sub.blend  = _bm.value;
              if (this.state.bundle.blends && this.state.bundle.blends.length){ this.state.bundle.blends[0] = _bm.value; }
            }
          }
        }
        this.isEntry = _ep.get('gd_entry') === '1';
      }

      // Pre-select a mode from the URL (?gd_mode=sub or ?gd_mode=bundle).
      // Lets landing pages drop the customer straight onto Subscribe (or Bundle).
      // If no URL param, fall back to the section's configured default mode
      // (default_mode setting - lets the PDP open on Subscribe as Best Value).
      let preMode = null;
      try {
        preMode = new URLSearchParams(window.location.search).get('gd_mode');
      } catch(e){ preMode = null; }
      if ((preMode === 'sub' && this.showSub) || (preMode === 'bundle' && this.hasBlend)){
        const preBtn = this.querySelector('[data-mode="'+preMode+'"]');
        this.switchMode(preMode, preBtn);
      } else if (this.defaultMode === 'sub' && this.showSub && this.subSizes().length){
        const subBtn = this.querySelector('[data-mode="sub"]');
        this.switchMode('sub', subBtn);
      } else {
        this.render();
      }

      // Entry Pack badge: small clay pill above the buy box when the customer
      // arrives via the ?gd_entry=1 landing link (replaces the old Sample Box).
      if (this.isEntry){
        const _b = document.createElement('div');
        _b.className = 'gd-buybox__entry-badge';
        _b.textContent = 'Entry Pack';
        _b.style.cssText = 'display:inline-block;background:var(--gd-clay,#B86B4B);color:#fff;font-size:0.7rem;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;padding:5px 12px;border-radius:999px;margin:0 0 12px;';
        this.insertBefore(_b, this.firstChild);
      }
    }

    distinct(key){
      const seen = [];
      this.variants.forEach(v=>{ if (v[key] && seen.indexOf(v[key])===-1) seen.push(v[key]); });
      return seen;
    }
    sizeWeight(s){
      // returns a sortable number: "250g"->250, "1kg"->1000, "10 drip bags"->10
      const str = String(s).toLowerCase();
      const num = parseFloat(str.replace(/[^0-9.]/g,'')) || 0;
      if (str.indexOf('kg') > -1) return num * 1000;
      return num;
    }
    sortSizes(arr){
      return arr.slice().sort((a,b)=> this.sizeWeight(a) - this.sizeWeight(b));
    }
    // Normalise Recharge selling plans into clean, deduped, sorted entries.
    // Raw names arrive like "Delivery every 4 weeks" or "6 Week(s) (duplicate)";
    // we extract the week count, label it "Every N weeks", drop duplicates of
    // the same interval, and sort ascending. Unparseable names pass through.
    normalizePlans(raw){
      const out = [];
      const seen = {};
      (raw||[]).forEach(pl=>{
        if (!pl || !pl.id) return;
        const m = String(pl.name||'').match(/(\d+)\s*week/i);
        const weeks = m ? parseInt(m[1],10) : 0;
        const label = weeks ? ('Every '+weeks+' week'+(weeks===1?'':'s')) : String(pl.name||'').trim();
        const key = weeks ? ('w'+weeks) : ('n'+label);
        if (seen[key]) return;
        seen[key] = true;
        out.push({ id: pl.id, name: label, weeks: weeks });
      });
      out.sort((a,b)=>{
        if (a.weeks && b.weeks) return a.weeks - b.weeks;
        if (a.weeks) return -1;
        if (b.weeks) return 1;
        return 0;
      });
      return out;
    }
    readBlends(){
      const tpl = this.querySelector('[data-blend-template]');
      const out = [];
      if (tpl){
        tpl.content.querySelectorAll('.gd-bb-blend-data').forEach(el=>{
          out.push({
            value: el.dataset.blendValue,
            label: el.dataset.label || el.dataset.blendValue,
            note:  el.dataset.note || '',
            roast: parseInt(el.dataset.roast,10) || 0,
            img:   el.dataset.img || ''
          });
        });
      }
      // Fallback: derive from variants if no blocks configured
      if (!out.length){
        this.distinct('blend').forEach(b=> out.push({ value:b, label:b, note:'', roast:0, img:'' }));
      }
      return out;
    }
    subSizes(){ return this.sizes.filter(s=> this.subExclude.indexOf(s)===-1); }
    sizeNum(s){ return (s||'').replace(/ drip bags| bags/i,''); }
    isBags(s){ return /bags?/i.test(String(s)); }
    gramsOf(s){ const n = parseFloat(String(s).replace(/[^0-9.]/g,''))||0; return /kg/i.test(String(s)) ? n*1000 : n; }
    sizeUnit(s){ return this.isBags(s) ? 'drip bags' : ''; }
    sizeWord(s){ return this.isBags(s) ? (this.sizeNum(s)+' drip bags') : this.sizeNum(s); }

    money(cents){ return '$' + (cents/100).toFixed(2); }

    findVariant(blend,size,grind){
      return this.variants.find(v=>
        (!this.hasBlend || v.blend===blend) && v.size===size && (!this.hasGrind || v.grind===grind)
      );
    }

    // ---------- availability (sold-out states) ----------
    // A variant is buyable unless Liquid said available:false. A missing flag
    // counts as available, so in-stock products behave exactly as before.
    isAvail(v){ return !!v && v.available !== false; }
    isSoldOut(v){ return !!v && v.available === false; }
    // Bundle picker: a size/grind is sold out when no blend can be bought in it.
    comboSoldOut(size, grind){
      const vs = this.blends.map(b=> this.findVariant(b.value, size, grind)).filter(Boolean);
      return vs.length > 0 && !vs.some(v=> this.isAvail(v));
    }
    // Shown at the top of the panel, on load, when every variant is sold out.
    soldOutNote(){
      if (!this.allSoldOut) return '';
      const rotm = /roast of the month/i.test(this.productTitle);
      const shop = this.hasGrind ? '/collections/coffee-beans' : '/collections/drip-bags-blends';
      return '<div class="gd-bb__soldout-note"><strong>Sold out</strong><span>'+(rotm ? "This month's roast has sold out." : 'This coffee has sold out for now.')+'</span> <a href="'+shop+'">Shop our other coffees</a></div>';
    }
    // Pantry Bags only: the "Milk or black?" blend-choice helper (change c).
    // Primary gate is the exact handle; the title fallback is scoped so it can
    // never fire on Beans/Travel or the monthly roast.
    isPantryBags(){
      if (this.productHandle === 'drip-coffee-bags-pantry') return true;
      return /pantry/i.test(this.productTitle) && !this.hasGrind && !/roast of the month/i.test(this.productTitle);
    }

    switchMode(mode, btn){
      if (mode==='bundle'){
        // toggle accordion: if already bundle, collapse back to once
        this.mode = (this.mode==='bundle') ? 'once' : 'bundle';
      } else {
        this.mode = mode;
      }
      // paint mode chrome
      this.querySelectorAll('.gd-buybox__mode').forEach(b=>{
        const on = b.dataset.mode === this.mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on?'true':'false');
      });
      const bundleBtn = this.querySelector('.gd-buybox__bundle-toggle');
      if (bundleBtn){
        const bundleOpen = this.mode==='bundle';
        bundleBtn.classList.toggle('is-open', bundleOpen);
        bundleBtn.setAttribute('aria-expanded', bundleOpen?'true':'false');
        const caret = bundleBtn.querySelector('.gd-buybox__caret');
        if (caret) caret.innerHTML = bundleOpen ? '&#9652;' : '&#9662;';
      }
      this.render();
    }

    // ---------- shared UI pieces ----------
    sizePills(scope, sizes){
      if (!sizes || sizes.length <= 1) return '';
      const sel = this.state[scope].size;
      return '<p class="gd-bb__label">'+(this.isBags(sizes[0]||'')?'Pack size':'Bag size')+'</p><div class="gd-bb__pills" role="radiogroup" aria-label="Size">' +
        sizes.map(s=>{
          const on = s===sel;
          const unit = this.sizeUnit(s);
          const so = this.isSoldOut(this.findVariant(this.state[scope].blend, s, this.state[scope].grind));
          return '<button type="button" class="gd-bb__pill'+(on?' is-on':'')+(so?' is-soldout':'')+'" data-size="'+s.replace(/"/g,'')+'" role="radio" aria-checked="'+(on?'true':'false')+'"><span class="gd-bb__pill-num">'+this.sizeNum(s)+'</span>'+(unit?'<span class="gd-bb__pill-unit">'+unit+'</span>':'')+'</button>';
        }).join('') + '</div>';
    }
    grindSelect(scope){
      if (!this.hasGrind) return '';
      const sel = this.state[scope].grind;
      const so = this.grinds.filter(g=> this.isSoldOut(this.findVariant(this.state[scope].blend, this.state[scope].size, g)));
      return '<p class="gd-bb__label">Grind</p>'+this.customDropdown(this.grinds, sel, 'grind', so);
    }
    // Reusable GD-styled dropdown. `target` keys the wiring (grind | bgrind | freq).
    // items can be plain strings (grinds) or {name} objects (freq plans).
    customDropdown(items, current, target, soldOut){
      const names = items.map(i => (typeof i === 'string') ? i : i.name);
      const so = soldOut || [];
      return '<div class="gd-bb__dropdown" data-dropdown="'+target+'">'+
        '<button type="button" class="gd-bb__dropdown-toggle'+(so.indexOf(current)>-1?' is-soldout':'')+'" data-dropdown-toggle aria-haspopup="listbox" aria-expanded="false">'+
          '<span class="gd-bb__dropdown-value">'+current+'</span>'+
          '<span class="gd-bb__dropdown-caret" aria-hidden="true">&#9662;</span>'+
        '</button>'+
        '<ul class="gd-bb__dropdown-list" role="listbox" data-dropdown-list hidden>'+
          names.map(n=>'<li class="gd-bb__dropdown-opt'+(n===current?' is-selected':'')+(so.indexOf(n)>-1?' is-soldout':'')+'" role="option" data-dropdown-opt="'+n.replace(/"/g,'&quot;')+'" aria-selected="'+(n===current?'true':'false')+'" tabindex="0">'+n+'</li>').join('')+
        '</ul>'+
      '</div>';
    }
    blendRadios(scope){
      if (!this.hasBlend) return '';
      const sel = this.state[scope].blend;
      const help = this.isPantryBags() ? '<p class="gd-blend-choice-help"><strong>Milk or black?</strong> Start with Hodophile for milk. For black coffee, try Wayfarer for a balanced cup or Nemophilist for a fuller-bodied cup. All three work either way.</p>' : '';
      return '<p class="gd-bb__label">Choose your '+(this.hasGrind?'bean':'blend')+'</p>'+help+'<div class="gd-bb__blends" role="radiogroup" aria-label="Choose blend">'+
        this.blends.map(b=>this.blendBtn(b, b.value===sel, 'single', this.isSoldOut(this.findVariant(b.value, this.state[scope].size, this.state[scope].grind)))).join('')+'</div>';
    }
    blendBtn(b, on, kind, soldOut){
      const img = b.img
        ? '<span class="gd-bb__blend-img"><img src="'+b.img+'" alt="" loading="lazy"></span>'
        : '<span class="gd-bb__blend-img gd-bb__blend-img--ph"><span>'+(b.label?b.label[0]:'?')+'</span></span>';
      const roast = b.roast ? '<span class="gd-bb__roast">'+[1,2,3,4,5].map(i=>'<span class="gd-bb__drop'+(i<=b.roast?' is-on':'')+'"></span>').join('')+'</span>' : '';
      return '<button type="button" class="gd-bb__blend'+(on?' is-on':'')+(soldOut?' is-soldout':'')+'" data-blend="'+b.value.replace(/"/g,'')+'" data-kind="'+kind+'" role="radio" aria-checked="'+(on?'true':'false')+'">'+
        img+'<span class="gd-bb__blend-info"><span class="gd-bb__blend-name">'+b.label+'</span>'+(b.note?'<span class="gd-bb__blend-note">'+b.note+'</span>':'')+roast+'</span>'+
        '<span class="gd-bb__blend-check" aria-hidden="true">✓</span></button>';
    }
    qtyRow(scope, label){
      const v = this.state[scope].qty;
      return '<div class="gd-bb__qty"><span class="gd-bb__label gd-bb__label--inline">'+label+'</span>'+
        '<span class="gd-bb__stepper"><button type="button" class="gd-bb__step" data-qty="-" '+(v<=1?'disabled':'')+'>−</button>'+
        '<span class="gd-bb__qty-val">'+v+'</span>'+
        '<button type="button" class="gd-bb__step" data-qty="+">+</button></span></div>';
    }
    cta(txt, enabled, soldOut){
      return '<button type="button" class="gd-bb__add gd-btn gd-btn--primary'+(soldOut?' is-soldout':'')+'" data-add '+(enabled?'':'disabled')+'>'+txt+'</button>';
    }

    // ---------- sticky mobile add-to-cart bar ----------
    // Mirrors the buy box's live state into a fixed bottom bar on mobile.
    // When the selection is ready it adds the current config; when it isn't
    // (e.g. a half-built bundle) it scrolls back up to the builder instead.
    buildSticky(){
      const el = document.createElement('div');
      el.className = 'gd-bb-sticky';
      el.hidden = true;
      el.innerHTML = '<div class="gd-bb-sticky__inner">'
        + (this.productImage ? '<img class="gd-bb-sticky__thumb" src="'+this.productImage+'" alt="" loading="lazy">' : '')
        + '<div class="gd-bb-sticky__txt"><span class="gd-bb-sticky__title">'+(this.productTitle||'')+'</span><span class="gd-bb-sticky__info" data-sk-info></span></div>'
        + '<button type="button" class="gd-bb-sticky__btn gd-btn gd-btn--primary" data-sk-btn></button>'
        + '</div>';
      document.body.appendChild(el);
      this._stickyEl = el;
      el.querySelector('[data-sk-btn]').addEventListener('click', ()=>{
        if (this._sticky && this._sticky.ready) this.addToCart();
        else this.scrollIntoView({ behavior:'smooth', block:'center' });
      });
      const onScroll = ()=>{
        if (!this._stickyEl) return;
        const anchor = this.panel || this;
        const r = anchor.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        // GD CRO 17 Oct 2026: show as soon as the buy box enters the viewport
        // (its top crosses the bottom of the screen), instead of only after the
        // whole buy box has scrolled past. Hide it while the buy box's own Add
        // button is on screen so there are never two Add buttons visible.
        const reached = r.top < vh;
        const add = this.querySelector('[data-add]');
        let addVisible = false;
        if (add){
          const ar = add.getBoundingClientRect();
          addVisible = ar.height > 0 && ar.top < (vh - 72) && ar.bottom > 72;
        }
        const show = reached && !addVisible;
        this._stickyEl.hidden = !show;
        // nudge floating bubbles (Drop Bot, free gift) up so they clear the bar
        document.body.classList.toggle('gd-sticky-on', show);
        // lets CSS keep the Drop Bot launcher off the buy box on mobile
        document.body.classList.toggle('gd-bb-inview', r.top < vh && r.bottom > 0);
      };
      this._stickyScroll = onScroll;
      // capture phase + document target: this theme scrolls a custom container,
      // not the window, so a normal (bubble) window scroll listener never fires.
      window.addEventListener('scroll', onScroll, { passive:true, capture:true });
      document.addEventListener('scroll', onScroll, { passive:true, capture:true });
      window.addEventListener('resize', onScroll, { passive:true });
      onScroll();
    }
    updateSticky(){
      const s = this._sticky;
      if (!s) return;
      if (!this._stickyEl) this.buildSticky();
      const info = this._stickyEl.querySelector('[data-sk-info]');
      const btn = this._stickyEl.querySelector('[data-sk-btn]');
      if (info) info.textContent = s.info;
      if (btn){
        btn.textContent = s.btn;
        // Sold out: say so, but never let the sticky button add (or scroll).
        btn.disabled = !!s.soldOut;
        btn.classList.toggle('is-soldout', !!s.soldOut);
      }
      this._stickyEl.classList.toggle('is-finish', !s.ready && !s.soldOut);
    }

    // ---------- render per mode ----------
    render(){
      this.hideError();
      if (this.mode==='once') this.renderSingle('once');
      else if (this.mode==='sub') this.renderSingle('sub');
      else this.renderBundle();
      this.wire();
      this.updateSticky();
    }

    renderSingle(scope){
      const isSub = scope==='sub';
      const sizes = isSub ? this.subSizes() : this.sizes;
      if (isSub && this.subSizes().indexOf(this.state.sub.size)===-1) this.state.sub.size = this.subSizes()[0];
      const st = this.state[scope];
      const v = this.findVariant(st.blend, st.size, st.grind);
      const soldOut = this.isSoldOut(v);
      const ready = !!v && !soldOut;
      this._sticky = { ready:false, info:'Choose your options', btn:'Choose your options' };
      let priceHtml = '';
      if (v){
        let cents = Math.round(parseFloat(v.price)) * st.qty;
        if (isSub && this.subDisc>0){
          const was = cents;
          cents = Math.round(cents*(1-this.subDisc/100));
          const saved = was - cents;
          priceHtml = '<span class="gd-bb__price-now">'+this.money(cents)+'</span><span class="gd-bb__price-was">'+this.money(was)+'</span><span class="gd-bb__save">Save '+this.money(saved)+' every delivery + free shipping</span>';
        } else {
          priceHtml = '<span class="gd-bb__price-now">'+this.money(cents)+'</span>';
        }
        if (this.isBags(st.size)){
          const tb = (parseInt(this.sizeNum(st.size),10)||0) * st.qty;
          if (tb>0) priceHtml += '<span class="gd-bb__per-bag" style="display:block;font-size:0.85rem;opacity:0.7;margin-top:2px;">'+this.money(Math.round(cents/tb))+' per drip bag</span>';
        } else {
          const grams = this.gramsOf(st.size) * st.qty;
          if (grams>0) priceHtml += '<span class="gd-bb__per-bag" style="display:block;font-size:0.85rem;opacity:0.7;margin-top:2px;">'+this.money(Math.round(cents/grams*100))+' per 100g</span>';
        }
        this._sticky = { ready:true, info: this.money(cents) + (isSub && this.subDisc>0 ? ' · save '+this.subDisc+'%' : ''), btn: isSub ? 'Subscribe' : 'Add to cart' };
        if (soldOut) this._sticky = { ready:false, soldOut:true, info:'Sold out', btn:'Sold out' };
      }

      let html = '<div class="gd-bb__face'+(isSub?' gd-bb__face--sub':'')+'">';
      html += this.soldOutNote();
      if (isSub){
        // frequency selector from real plans (fallback to standard list)
        const freqs = this.plans.length ? this.plans : [{id:'',name:'Every 4 weeks'},{id:'',name:'Every 6 weeks'},{id:'',name:'Every 8 weeks'}];
        if (!st.freq || !freqs.some(f=>f.name===st.freq)) st.freq = freqs[0].name;
        html += '<div class="gd-bb__freq"><span class="gd-bb__label gd-bb__label--inline">Deliver</span>'+
          this.customDropdown(freqs, st.freq, 'freq')+
        '</div>';
      }
      html += this.sizePills(scope, sizes);
      html += this.grindSelect(scope);
      html += this.blendRadios(scope);
      html += this.qtyRow(scope, isSub?'Quantity per delivery':'Quantity');
      if (isSub && this.giftTpl){ html += this.giftTpl.innerHTML; }
      html += '<div class="gd-bb__summary">'+priceHtml+'</div>';
      const label = soldOut ? 'Sold out' : isSub
        ? (ready ? 'Subscribe — '+this.sizeWord(st.size)+' / '+(st.freq||'') : 'Choose your options')
        : (ready ? 'Add '+this.sizeWord(st.size)+' to cart' : 'Choose your options');
      html += this.cta(label, ready, soldOut);
      if (soldOut && !this.allSoldOut) html += '<p class="gd-bb__soldout-hint">This option has sold out. Please choose another.</p>';
      if (isSub){
        const assure = this.assureText || 'No lock-in - pause, skip, swap or cancel anytime.';
        const link = this.manageLink ? ' <a class="gd-bb__assure-link" href="'+this.manageLink+'" target="_blank" rel="noopener">'+(this.assureLabel || 'See how easy it is')+'</a>' : '';
        html += '<p class="gd-bb__assure">'+assure+link+'</p>';
      }
      if (isSub && this.subMode==='mock'){
        html += '<p class="gd-bb__sub-flag">Subscription checkout is being finalised — this preview shows the experience.</p>';
      }
      html += '</div>';
      this.panel.innerHTML = html;
    }

    renderBundle(){
      const st = this.state.bundle;
      const tiers = [
        {c:2, label:'2 bag bundle', save:'Save '+this.disc2+'%'},
        {c:3, label:'3 bag bundle', save:'Save '+this.disc3+'% · Best value'}
      ];
      if (st.blends.length !== 3) st.blends = [st.blends[0]||null, st.blends[1]||null, st.blends[2]||null];

      let html = '<div class="gd-bb__face gd-bb__face--bundle">';
      html += this.soldOutNote();
      // step 1: count
      html += '<p class="gd-bb__step-h">1 &middot; How many bags?</p>';
      html += '<div class="gd-bb__tiers">'+tiers.map(t=>{
        const on = t.c===st.count;
        return '<button type="button" class="gd-bb__tier'+(on?' is-on':'')+'" data-count="'+t.c+'"><span class="gd-bb__tier-label">'+t.label+'</span><span class="gd-bb__tier-save">'+t.save+'</span></button>';
      }).join('')+'</div>';
      // step 2: size
      html += '<p class="gd-bb__step-h">2 &middot; Pack size <span class="gd-bb__muted">(of each bag)</span></p>';
      html += '<div class="gd-bb__pills" role="radiogroup">'+this.sizes.map(s=>{
        const on = s===st.size;
        const unit = this.sizeUnit(s);
        const so = this.comboSoldOut(s, st.grind);
        return '<button type="button" class="gd-bb__pill'+(on?' is-on':'')+(so?' is-soldout':'')+'" data-bsize="'+s.replace(/"/g,'')+'"><span class="gd-bb__pill-num">'+this.sizeNum(s)+'</span>'+(unit?'<span class="gd-bb__pill-unit">'+unit+'</span>':'')+'</button>';
      }).join('')+'</div>';
      // step 2b: grind (Beans only) - one grind for whole bundle
      let stepNo = 3;
      if (this.hasGrind){
        html += '<p class="gd-bb__step-h">3 &middot; Grind <span class="gd-bb__muted">(for the whole bundle)</span></p>';
        html += this.customDropdown(this.grinds, st.grind, 'bgrind', this.grinds.filter(g=> this.comboSoldOut(st.size, g)));
        stepNo = 4;
      }
      // step 3/4: choose blends with steppers
      const chosen = st.blends.filter(Boolean).length;
      html += '<p class="gd-bb__step-h">'+stepNo+' &middot; Choose your '+(this.hasGrind?'beans':'bags')+' <span class="gd-bb__muted">— '+chosen+' of '+st.count+'</span></p>';
      html += '<div class="gd-bb__bblends">'+this.blends.map(b=>{
        const cnt = st.blends.filter(x=>x===b.value).length;
        const full = chosen>=st.count;
        const so = this.isSoldOut(this.findVariant(b.value, st.size, st.grind));
        return '<div class="gd-bb__bblend'+(cnt>0?' is-on':'')+(so?' is-soldout':'')+'">'+
          (b.img?'<span class="gd-bb__blend-img"><img src="'+b.img+'" alt="" loading="lazy"></span>':'<span class="gd-bb__blend-img gd-bb__blend-img--ph"><span>'+(b.label?b.label[0]:'?')+'</span></span>')+
          '<span class="gd-bb__blend-info"><span class="gd-bb__blend-name">'+b.label+'</span>'+(b.note?'<span class="gd-bb__blend-note">'+b.note+'</span>':'')+'</span>'+
          '<span class="gd-bb__stepper"><button type="button" class="gd-bb__step" data-bb-minus="'+b.value.replace(/"/g,'')+'" '+(cnt<=0?'disabled':'')+'>−</button><span class="gd-bb__qty-val">'+cnt+'</span><button type="button" class="gd-bb__step" data-bb-plus="'+b.value.replace(/"/g,'')+'" '+((full||so)?'disabled':'')+'>+</button></span>'+
          '</div>';
      }).join('')+'</div>';
      // qty (how many of this bundle)
      html += this.qtyRow('bundle','How many of this bundle?');

      // totals
      const done = chosen===st.count;
      // a picked bag that is sold out in this size/grind blocks the add
      const pickedSoldOut = st.blends.some(bv=> bv && this.isSoldOut(this.findVariant(bv, st.size, st.grind)));
      const canAdd = done && !pickedSoldOut;
      let sub = 0;
      st.blends.forEach(bv=>{ if(bv){ const v=this.findVariant(bv, st.size, st.grind); if(v) sub += Math.round(parseFloat(v.price)); } });
      sub = sub * st.qty;
      const pct = st.count>=3 ? this.disc3 : this.disc2;
      const total = Math.round(sub*(1-pct/100));
      const saved = sub - total;
      const rem = st.count - chosen;
      const bagsCount = st.count*st.qty;
      let summaryRight, addLabel;
      if (this.isBags(st.size)){
        const totalBags = bagsCount * (parseInt(this.sizeNum(st.size),10)||0);
        summaryRight = bagsCount+' × '+this.sizeNum(st.size)+' = <strong>'+totalBags+' drip bags</strong>';
        addLabel = done ? ('Add '+totalBags+' drip bags to cart') : ('Pick '+rem+' more bag'+(rem===1?'':'s'));
      } else {
        summaryRight = '<strong>'+bagsCount+' × '+this.sizeNum(st.size)+'</strong>';
        addLabel = done ? ('Add '+bagsCount+' × '+this.sizeNum(st.size)+' to cart') : ('Pick '+rem+' more bag'+(rem===1?'':'s'));
      }
      html += '<div class="gd-bb__summary-row"><span class="gd-bb__muted">Your bundle</span><span class="gd-bb__bundle-count">'+summaryRight+'</span></div>';
      if (done){
        let perBagB = '';
        if (this.isBags(st.size)){
          const tb = bagsCount * (parseInt(this.sizeNum(st.size),10)||0);
          if (tb>0) perBagB = '<span class="gd-bb__per-bag" style="display:block;font-size:0.85rem;opacity:0.7;margin-top:2px;">'+this.money(Math.round(total/tb))+' per drip bag</span>';
        } else {
          const grams = bagsCount * this.gramsOf(st.size);
          if (grams>0) perBagB = '<span class="gd-bb__per-bag" style="display:block;font-size:0.85rem;opacity:0.7;margin-top:2px;">'+this.money(Math.round(total/grams*100))+' per 100g</span>';
        }
        html += '<div class="gd-bb__summary"><span class="gd-bb__price-now">'+this.money(total)+'</span><span class="gd-bb__price-was">'+this.money(sub)+'</span><span class="gd-bb__save">Save '+this.money(saved)+' ('+pct+'%)</span>'+perBagB+'</div>';
      }
      if (done){
        this._sticky = { ready:true, info: this.money(total) + ' · ' + (this.isBags(st.size) ? (bagsCount*(parseInt(this.sizeNum(st.size),10)||0))+' bags' : bagsCount+' × '+this.sizeNum(st.size)), btn:'Add to cart' };
      } else {
        this._sticky = { ready:false, info:'Pick '+rem+' more bag'+(rem===1?'':'s'), btn:'Finish bundle' };
      }
      if (this.allSoldOut || pickedSoldOut){
        addLabel = this.allSoldOut ? 'Sold out' : 'Swap out sold-out bags';
        this._sticky = this.allSoldOut
          ? { ready:false, soldOut:true, info:'Sold out', btn:'Sold out' }
          : { ready:false, info:'Swap out sold-out bags', btn:'Finish bundle' };
      }
      html += this.cta(addLabel, canAdd, this.allSoldOut);
      html += '</div>';
      this.panel.innerHTML = html;
    }

    // ---------- wiring (delegated each render) ----------
    wire(){
      const p = this.panel;
      const scope = this.mode==='sub' ? 'sub' : (this.mode==='once'?'once':'bundle');

      p.querySelectorAll('[data-size]').forEach(b=> b.onclick=()=>{ this.state[scope].size=b.dataset.size; this.render(); });
      p.querySelectorAll('[data-bsize]').forEach(b=> b.onclick=()=>{ this.state.bundle.size=b.dataset.bsize; this.render(); });

      // Custom dropdowns (grind, bundle grind, sub frequency) - all share the same component.
      // data-dropdown="<target>" routes the chosen value to the right state field.
      p.querySelectorAll('[data-dropdown]').forEach(dd => {
        const target = dd.dataset.dropdown;
        const toggle = dd.querySelector('[data-dropdown-toggle]');
        const list = dd.querySelector('[data-dropdown-list]');
        const opts = dd.querySelectorAll('[data-dropdown-opt]');
        const close = ()=> { list.hidden = true; toggle.setAttribute('aria-expanded','false'); dd.classList.remove('is-open'); };
        const open = ()=> { list.hidden = false; toggle.setAttribute('aria-expanded','true'); dd.classList.add('is-open'); };
        const apply = (val)=> {
          if (target === 'freq') this.state.sub.freq = val;
          else if (target === 'bgrind') this.state.bundle.grind = val;
          else if (target === 'grind') this.state[scope].grind = val;
          close(); this.render();
        };
        toggle.onclick = (e)=> { e.stopPropagation(); list.hidden ? open() : close(); };
        opts.forEach(o => {
          o.onclick = (e)=> { e.stopPropagation(); apply(o.dataset.dropdownOpt); };
          o.onkeydown = (e)=> {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); apply(o.dataset.dropdownOpt); }
            if (e.key === 'ArrowDown') { e.preventDefault(); (o.nextElementSibling || opts[0]).focus(); }
            if (e.key === 'ArrowUp') { e.preventDefault(); (o.previousElementSibling || opts[opts.length-1]).focus(); }
            if (e.key === 'Escape') { close(); toggle.focus(); }
          };
        });
        document.addEventListener('click', (e)=> { if (!dd.contains(e.target)) close(); }, { once: true });
      });

      p.querySelectorAll('[data-blend]').forEach(b=> b.onclick=()=>{ this.state[scope].blend=b.dataset.blend; this.render(); });

      p.querySelectorAll('[data-qty]').forEach(b=> b.onclick=()=>{
        const s=this.state[scope]; if(b.dataset.qty==='+') s.qty++; else if(s.qty>1) s.qty--; this.render();
      });
      p.querySelectorAll('[data-bb-plus]').forEach(b=> b.onclick=()=>{ this.bundleAdd(b.dataset.bbPlus); });
      p.querySelectorAll('[data-bb-minus]').forEach(b=> b.onclick=()=>{ this.bundleRemove(b.dataset.bbMinus); });

      p.querySelectorAll('[data-count]').forEach(b=> b.onclick=()=>{ this.state.bundle.count=parseInt(b.dataset.count,10); this.render(); });

      const add = p.querySelector('[data-add]'); if (add) add.onclick=()=> this.addToCart();
    }

    bundleAdd(val){
      const st=this.state.bundle; const chosen=st.blends.filter(Boolean).length;
      if (chosen>=st.count) return;
      const slot = st.blends.indexOf(null);
      if (slot>-1) st.blends[slot]=val; else st.blends.push(val);
      this.render();
    }
    bundleRemove(val){
      const st=this.state.bundle; const i=st.blends.indexOf(val);
      if (i>-1) st.blends[i]=null;
      this.render();
    }

    // ---------- add to cart ----------
    async addToCart(){
      let items=[]; let soldHit=false;
      if (this.mode==='bundle'){
        const st=this.state.bundle; const id='gd-'+Date.now();
        for (let q=0;q<st.qty;q++){
          st.blends.forEach(bv=>{
            if(!bv) return;
            const v=this.findVariant(bv, st.size, st.grind);
            if(this.isSoldOut(v)) soldHit = true;
            if(v) items.push({ id:v.id, quantity:1, properties:{ 'Bundle': st.count+'-Bag Build', '_gd_bundle_id':id } });
          });
        }
      } else {
        const scope=this.mode==='sub'?'sub':'once';
        const st=this.state[scope];
        const v=this.findVariant(st.blend, st.size, st.grind);
        if(!v){ this.showError('Please choose your options.'); return; }
        if(this.isSoldOut(v)){ this.showError('Sorry, that option has sold out.'); return; }
        const item={ id:v.id, quantity:st.qty };

        if (this.mode==='sub'){
          // Mock mode: preview-only, never submits a subscription.
          if (this.subMode==='mock'){
            if (this.subLink){ window.location.href=this.subLink; return; }
            this.showError('Subscription checkout is being finalised. (Preview mode — backend coming soon.)');
            return;
          }
          // Live mode: attach the Recharge selling plan that matches the chosen
          // frequency. Hard guard: never let a subscription silently fall
          // through to the cart as a one-time purchase.
          const plan=this.plans.find(pl=> pl.name===st.freq) || this.plans[0];
          if (!plan || !plan.id){
            this.showError('Subscription options did not load. Please refresh the page and try again.');
            return;
          }
          item.selling_plan = plan.id;
        }
        items=[item];
      }
      if(soldHit){ this.showError('Sorry, one of your picks has sold out. Please swap it.'); return; }
      if(!items.length){ this.showError('Please choose your options.'); return; }

      const add=this.panel.querySelector('[data-add]');
      const oldLabel=add ? add.textContent : '';
      if(add){ add.disabled=true; add.textContent='Adding…'; }
      try{
        const res=await fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items}) });
        if(!res.ok){ const e=await res.json().catch(()=>({})); throw new Error(e.description||'Could not add to cart.'); }
        if(this.redirect==='checkout'){ window.location.href='/checkout'; return; }
        // Open Horizon's cart drawer (element: cart-drawer-component) and refresh
        // its contents via the Section Rendering API so the new items appear.
        const drawer=document.querySelector('cart-drawer-component');
        if(drawer){
          let cartJson=null;
          try{ cartJson=await (await fetch('/cart.js')).json(); }catch(e){}
          try{
            const wrapEl=drawer.closest('.shopify-section');
            const sid=wrapEl ? wrapEl.id.replace('shopify-section-','') : null;
            if(sid){
              const secs=await (await fetch(window.location.pathname+'?sections='+encodeURIComponent(sid))).json();
              const html=secs && secs[sid];
              if(html){
                const doc=new DOMParser().parseFromString(html,'text/html');
                const fresh=doc.querySelector('.cart-drawer__inner');
                const cur=drawer.querySelector('.cart-drawer__inner');
                if(fresh && cur){ cur.innerHTML=fresh.innerHTML; }
              }
            }
          }catch(e){}
          // Horizon cart event (see assets/events.js, CartAddEvent) - updates the cart bubble etc.
          document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cartJson,sourceId:'gd-buy-box',data:{source:'gd-buy-box',itemCount:cartJson?cartJson.item_count:0}}}));
          if(typeof drawer.open==='function'){ drawer.open(); }
          if(add){ add.disabled=false; add.textContent=oldLabel; }
        } else {
          window.location.href='/cart';
        }
      }catch(e){
        this.showError(e.message||'Could not add to cart. Please try again.');
        if(add){ add.disabled=false; add.textContent=oldLabel; }
      }
    }

    showError(m){ this.errorEl.hidden=false; this.errorEl.textContent=m; }
    hideError(){ this.errorEl.hidden=true; this.errorEl.textContent=''; }
  }

  customElements.define('gd-buy-box', GDBuyBox);
})();
